<template>
  <v-container class="ma-0 text-center d-inline">
    <v-card-title>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="serveSideFilter"
        style="width: 100%"
      >
        <v-text-field
          v-model="search"
          label="Search"
          append-icon="mdi-magnify"
          single-line
          clearable
          :rules="nameRules"
          clear-icon="mdi-close-circle-outline"
          @click:append="serveSideFilter"
          @click:clear="serveSideFilterReset"
        ></v-text-field>
      </v-form>
    </v-card-title>
    <div>
      <v-overlay :absolute="true" :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-treeview
        v-model="selection"
        :items="items"
        :selection-type="selectionType"
        :custom-filter="serveSideFilter"
        :load-children="fetchItems"
        :open.sync="open"
        :active.sync="active"
        :open-on-click="false"
        item-disabled="locked"
        hoverable
        return-object
        item-key="name"
      >
        <template v-slot:prepend="{ item, open }">
          <v-container d-flex v-if="!item.file">
            <v-icon small>{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
          </v-container>
          <v-icon small v-else>{{
            icons[item.file] ? icons[item.file] : icons["default"]
          }}</v-icon>
        </template>
        <template v-slot:label="{ item }">
          <v-container d-flex>
            <v-col class="mt-1 subtitle-2 text-left text-truncate">{{
              item.name
            }}</v-col>
          </v-container>
        </template>
        <template v-slot:append="{ item }" class="d-flex text-left">
          <v-row>
            <v-col class="d-flex pa-0">
              <v-col v-if="item.el_properties" class="text-right pa-0">
                <v-icon
                  class="mx-2"
                  v-if="
                    item.el_properties.storage_class
                      ? item.el_properties.storage_class.includes('GLACIER') ||
                        item.el_properties.storage_class.includes('DEEP')
                      : false
                  "
                  color="primary"
                  >mdi-snowflake</v-icon
                >
              </v-col>
            </v-col>
            <v-col class="d-flex pa-0" v-if="!item.file && !item.locked">
              <v-col v-if="kind !== 'Customer'" class="text-right pa-0">
                <v-icon
                  v-if="!item.el_properties.selected"
                  class="mx-2"
                  :color="item.checked"
                  :title="'select ' + item.name + ' project'"
                  @click="_selection(item)"
                  >mdi-selection</v-icon
                >
                <v-icon
                  v-else
                  class="mx-2"
                  :color="item.checked"
                  :title="'select ' + item.name + ' project'"
                  @click="_selection(item)"
                  >mdi-check-box-outline</v-icon
                >
              </v-col>
            </v-col>
            <v-col v-if="item.file" class="text-right pa-0">
              <v-icon
                class="mx-2"
                color="green"
                name="info"
                :title="'info of  ' + item.name"
                @click="infoItem(item)"
                dark
                >mdi-information-variant</v-icon
              >
            </v-col>
            <v-col class="d-flex pa-0">
              <v-col class="text-right pa-0">
                <v-icon
                  class="mx-2"
                  v-if="
                    item.file &&
                    userRole === 'Customer' &&
                    item.el_properties.confirmation_time === ''
                  "
                  color="primary"
                  :title="'confirm ' + item.name"
                  @click="confirm(item)"
                  >mdi-check</v-icon
                >
              </v-col>
              
              <v-col v-if="item.el_properties" class="text-right pa-0">
                <v-icon
                  v-if="
                    !item.el_properties.storage_class.includes('GLACIER') &&
                    !item.el_properties.storage_class.includes('DEEP')
                  "
                  class="mx-2"
                  color="blue"
                  name="download"
                  :title="'download ' + item.name"
                  @click="downloadFolder(item)"
                  dark
                  >mdi-download</v-icon
                >
                <v-icon
                  v-if="
                    item.el_properties.storage_class.includes('GLACIER') ||
                    item.el_properties.storage_class.includes('DEEP')
                  "
                  color="transparent"
                  class="mx-2"
                  name="transparent1"
                  >mdi-download</v-icon
                >
              </v-col>
              <v-col
                class="text-right pa-0"
              >
                <v-icon
                  v-if="
                    userRole !== 'Customer' &&
                    userRole !== 'Provider' &&
                    (kind === 'OperatorStorage' || (kind.includes('Provider') && item.masterPath && item.locked))
                  "
                  class="mx-2"
                  color="primary"
                  name="link"
                  title="make deliverable with customer using sftp"
                  @click="goto(item, 'move')"
                  >mdi-file-move</v-icon
                >
                <v-icon
                  v-if="
                    kind.includes('Provider') && !item.locked
                  "
                  class="mx-2"
                  color="transparent"
                  >mdi-file-move</v-icon
                >
              </v-col>
              <v-col
                class="text-right pa-0"
              >
                <v-icon
                  v-if="
                    (userRole !== 'Customer') &&
                    (kind === 'OperatorStorage' || ((kind === 'Operator_ProviderStorage') && item.locked))
                  "
                  class="mx-2"
                  color="primary"
                  name="link"
                  title="share with customer"
                  @click="goto(item, 'share')"
                  >mdi-share-variant</v-icon
                >
                <v-icon
                  v-if="
                    (userRole !== 'Customer') &&
                    (kind === 'OperatorStorage' || ((kind === 'Operator_ProviderStorage') && !item.locked))
                  "
                  class="mx-2"
                  color="transparent"
                  >mdi-share-variant</v-icon
                >
              </v-col>
              <v-col
                v-if="
                  (kind === 'Exchange' || kind === 'Operator_ExchangeStorage') &&
                  userRole !== 'Customer' &&
                  userRole !== 'Provider'
                "
                class="text-right pa-0"
              >
                <v-icon
                  v-if="
                    !item.file &&
                    item.masterPath
                  "
                  dark
                  class="mx-2"
                  color="success"
                  name="makeDeliverable"
                  :title="`make deliverable ${item.el_properties.path}`"
                  @click="setTreeProvider(item)"
                  >mdi-share-all</v-icon
                >
                <v-icon
                  v-else
                  color="transparent"
                  class="mx-2"
                  name="transparent1"
                  >mdi-delete</v-icon
                >
              </v-col>
              <v-col
                class="text-right pa-0"
              >
                <delete-with-confirm
                  v-if="
                    (kind !== 'Customer' &&
                      kind !== 'Operator_ProviderStorage' &&
                      item.masterPath &&
                      !item.locked) ||
                    kind === 'OperatorStorage'
                  "
                  :id="item.el_properties.name"
                  @deleted="deleteFolder(item)"
                />
                <v-icon
                  v-if="
                    item.locked &&
                    item.masterPath &&
                    kind !== 'Operator_ProviderStorage'
                  "
                  color="transparent"
                  class="mx-2"
                  name="transparent1"
                  >mdi-delete</v-icon
                >
              </v-col>
              <v-col
                class="text-right pa-0"
              >
                <v-icon
                  class="mx-2"
                  v-if="
                    (kind === 'Operator_ProviderStorage' &&
                      item.masterPath &&
                      userRole !== 'Operator') ||
                    (kind === 'Operator_ProviderStorage' &&
                      item.masterPath &&
                      userRole === 'Operator' &&
                      !item.locked)
                  "
                  :color="item.locked ? 'red' : 'primary'"
                  :title="(item.locked ? 'open ' : 'lock ') + item.name"
                  @click="setStateItem(item)"
                  >mdi-lock</v-icon
                >
                <v-icon
                  v-if="
                    (kind === 'Provider' && item.locked) ||
                    (!item.masterPath && kind !== 'Customer') ||
                    kind === 'OperatorStorage' ||
                    (item.masterPath &&
                      kind === 'Operator_ProviderStorage' &&
                      userRole === 'Operator' &&
                      item.locked)
                  "
                  color="transparent"
                  class="mx-2"
                  name="transparent2"
                  >mdi-lock</v-icon
                >
              </v-col>
            </v-col>
          </v-row>
        </template>
      </v-treeview>
    </div>
    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center" height="100%">
        <v-card-title class="mx-5 font-weight-bold">Info</v-card-title>
        <div class="pa-5 mx-12 px-12">
          <v-simple-table dense light>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, index) in selectedItemForInfo" :key="index">
                  <td
                    v-if="item !== '' && item !== null"
                    class="text-left font-weight-bold"
                  >
                    {{ index }}:
                  </td>
                  <td v-if="item !== '' && item !== null">
                    {{ item }}
                  </td>
                </tr>
                <tr v-if="!selectedItemForInfo">
                  <v-card-text>Please Reload Page</v-card-text>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-expansion-panels
            v-if="userRole.includes('Operator') || userRole.includes('Admin')"
          >
            <v-expansion-panel v-if="downloaderList.length > 0">
              <v-expansion-panel-header class="text-left font-weight-bold">
                Downloaded by
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">User</th>
                        <th class="text-left">Group</th>
                        <th class="text-left">Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in downloaderList" :key="item.user">
                        <td class="text-left">{{ item.user }}</td>
                        <td class="text-left">
                          {{ item.group.split("_").join(" ") }}
                        </td>
                        <td class="text-left">
                          {{ new Date(item.time).toUTCString() }}
                        </td>
                      </tr>
                      <tr v-if="!downloaderList">
                        <v-card-text>0 User downloaded this file</v-card-text>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="confirmerList.length > 0">
              <v-expansion-panel-header class="text-left font-weight-bold">
                Confirmed by
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">User</th>
                        <th class="text-left">Group</th>
                        <th class="text-left">Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in confirmerList" :key="item.user">
                        <td class="text-left">{{ item.user }}</td>
                        <td class="text-left">
                          {{ item.group.split("_").join(" ") }}
                        </td>
                        <td class="text-left">
                          {{ new Date(item.time).toUTCString() }}
                        </td>
                      </tr>
                      <tr v-if="!confirmerList">
                        <v-card-text>0 User Confirmed this file</v-card-text>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <MakeDeliverableConfirm
      :id="itemToDeliver"
      @deliver="makeDeliverable()"
      @close_md_dialog="closeMdDialog()"
      :dialog.sync="md_dialog"
      :bucket="getBucket()"
    />
    <Confirm
      :dialog.sync="dialog"
      :message.sync="itemToLock.msg"
      @confirm="sendConfirm()"
    />
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import DeleteWithConfirm from "@/components/DeleteWithConfirm";
import MakeDeliverableConfirm from "@/components/MakeDeliverableConfirm";
import Confirm from "@/components/Confirm.vue";
import path from "path";
import awsmobile from "@/api/aws-exports";
import router from "@/router";
import { STAGE } from "@/constants.js";

export default {
  props: {
    kind: {
      default: "",
    },
    bucket: {
      default: "",
    },
  },
  data: () => ({
    sheet: false,
    selectionType: "independent",
    nameRules: [(v) => !v || v.length <= 200 || "too long field"],
    selection_icon: "mdi-selection",
    icons: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      PDF: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-document-outline",
      xls: "mdi-file-excel",
      xlsx: "mdi-file-excel",
      jpg: "mdi-file-image",
      mp4: "mdi-file-video",
      mkv: "mdi-file-video",
      mp3: "mdi-music",
      dwg: "mdi-database",
      zip: "mdi-folder-zip-outline",
      "7z": "mdi-folder-zip-outline",
      docx: "mdi-file-document-outline",
      doc: "mdi-file-document-outline",
      dwl: "mdi-file-document-outline",
      dwl2: "mdi-file-document-outline",
      default: "mdi-file-document-outline",
    },
    selection: [],
    dialog: false,
    md_dialog: false,
    loading: false,
    obj: {
      path: "",
      folderState: "Closed",
    },
    itemToLock: {},
    itemToDeliver: {},
    selectedItemForInfo: {},
    search: "",
    open: [],
    active: [],
    valid: true,
  }),
  components: {
    DeleteWithConfirm,
    Confirm,
    MakeDeliverableConfirm
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      userRole: (state) => state.userRole,
      paths_operator: (state) => state.paths_operator,
      operatorFolder: (state) => state.operatorFolder,
      downloaderList: (state) => state.downloaderList,
      confirmerList: (state) => state.confirmerList,
      folderToUploadSharedFile: (state) => state.folderToUploadSharedFile,
    }),
    items() {
      return this.paths_operator;
    }
  },
  methods: {
    getBucket() {
      return this.kind.includes("Provider") ? awsmobile["operator_bucket"] : awsmobile["provider_bucket"];
    },
    fatherPath(name) {
      const str_arr = name.split("/");
      const str=str_arr[0] + "/";
      return str;
    },
    async _selection(val) {
      this.$store.commit("setFolderToUpload", "");
      let folderToUpload = {
        path: val.el_properties.path,
        name: val.el_properties.name,
      };
      await this.$store.dispatch("setFolderToUploadAction", folderToUpload);
    },
    async downloadFolder(item) {
      await this.$store.dispatch("getDownloadLink", {
        bucket: item.el_properties.name.includes("PROV@") ? `prysmian-provider-${STAGE}` : this.bucket,
        father: item.el_properties.name,
      });
    },
    async deleteFolder(item) {
      this.$store.dispatch("dispatchError", {
        text: { message: "Deletion started" }.message.substr(0, 50) + "...",
        type: "warning",
      });
      if (!item.file) {
        await this.$store.dispatch("getFilePathAction", {
          bucket: this.bucket,
          father: item.el_properties.name,
          action: "delete",
        });
      } else {
        await this.$store.dispatch("deleteFolderFromTree", {
          bucket: this.bucket,
          path: [{ name: item.el_properties.name }],
        });
      }
    },
    goto(item, action) {
      // if(action == "move") {
      //   let folderOperator = {
      //     path: item.el_properties.path,
      //     name: item.el_properties.name,
      //     parent: (masterPath === "" || masterPath.endsWith("/")) ? masterPath : masterPath.concat("/"),
      //     action
      //   };
      //   this.$store.dispatch("setOperatorFolder", folderOperator);
      //   this.setTreeProvider(item);
      // } else {
        let splittedName = item.el_properties.name.split("/")
        var masterPath = "";
        if (splittedName[splittedName.length-1] == "" && splittedName.length) {
          splittedName.pop();
          splittedName.pop();
          masterPath = splittedName.join("/");
        } else {
          splittedName.pop();
          masterPath = splittedName.join("/");
        }
        let folderOperator = {
          path: item.el_properties.path,
          name: item.el_properties.name,
          parent: (masterPath === "" || masterPath.endsWith("/")) ? masterPath : masterPath.concat("/"),
          action
        };
        this.$store.dispatch("setOperatorFolder", folderOperator);
      // }
      router.push("/share-folder/" + item.name);
    },
    infoItem(item) {
      this.selectedItemForInfo = {};
      this.$store.dispatch("getDownloadList", item.el_properties.name);
      this.$store.dispatch("getConfirmedList", item.el_properties.name);
      this.selectedItemForInfo.Path = item.el_properties.path
        ? item.el_properties.path
        : "";
      this.selectedItemForInfo["Lock Time"] = item.el_properties.lock_time
        ? new Date(item.el_properties.lock_time).toUTCString()
        : "";
      this.selectedItemForInfo.Locked = item.el_properties.locked
        ? item.el_properties.locked
        : "";
      this.selectedItemForInfo["Storage Class"] = item.el_properties
        .storage_class
        ? item.el_properties.storage_class.split("_").join(" ")
        : "";
      this.selectedItemForInfo["Creation Time"] = item.el_properties
        .creation_time
        ? new Date(item.el_properties.creation_time).toUTCString()
        : "";
      this.selectedItemForInfo.Creator = item.el_properties.creator
        ? item.el_properties.creator
        : "";
      this.selectedItemForInfo["Locked by"] = item.el_properties.locked_by
        ? item.el_properties.locked_by
        : "";
      let tmp = item.el_properties.size ? item.el_properties.size : "";
      switch (true) {
        case tmp < 1000:
          tmp = tmp + " byte";
          break;
        case tmp >= 1000 && tmp < 1000000:
          tmp = (tmp / 1024).toFixed(2) + " Kb";
          break;
        case tmp >= 1000000 && tmp < 1050000000:
          tmp = (tmp / 1024 / 1024).toFixed(2) + " Mb";
          break;
        case tmp >= 1040000000 && tmp < 1080000000000:
          tmp = (tmp / 1024 / 1024 / 1024).toFixed(2) + " Gb";
          break;
        default:
          tmp = (tmp / 1024 / 1024 / 1024 / 1024).toFixed(2) + " Tb";
          break;
      }
      this.selectedItemForInfo.Size = tmp;
      this.selectedItemForInfo["Sharing Time"] = item.el_properties.sharing_time
        ? new Date(item.el_properties.sharing_time).toUTCString()
        : "";
      this.selectedItemForInfo["Shared by"] = item.el_properties.shared_by
        ? item.el_properties.shared_by
        : "";
      this.selectedItemForInfo["Confirmation Time"] = item.el_properties
        .confirmation_time
        ? new Date(item.el_properties.confirmation_time).toUTCString()
        : "";
      this.selectedItemForInfo["Confirmed by"] = item.el_properties.confirmed_by
        ? item.el_properties.confirmed_by
        : "";
      this.selectedItemForInfo.Downloaded = item.el_properties.downloaded
        ? item.el_properties.downloaded
        : "";
      this.selectedItemForInfo["Operator Download Time"] = item.el_properties
        .operator_download_time
        ? new Date(item.el_properties.operator_download_time).toUTCString()
        : "";
      this.selectedItemForInfo["Provider Download Time"] = item.el_properties
        .provider_download_time
        ? new Date(item.el_properties.provider_download_time).toUTCString()
        : "";
      this.selectedItemForInfo["Download Time"] = item.el_properties
        .download_time
        ? new Date(item.el_properties.download_time).toUTCString()
        : "";
      this.selectedItemForInfo["Last Download User"] = item.el_properties
        .download_user
        ? item.el_properties.download_user
        : "";
      this.sheet = true;
    },
    setStateItem(item) {
      let tmp = item.el_properties.name.split("/");
      let tmp2 = item.el_properties.path.split("/");
      let str = "";
      let str2 = "";
      let end = false;
      for (let index = 0; index < tmp.length; index++) {
        if (!end) {
          str = path.join(str, tmp[index]);
          str2 = path.join(str2, tmp2[index]);
          let temp;
          if (tmp[index].includes("@") || tmp[index].includes("#")) {
            temp = tmp[index].includes("@")
              ? tmp[index].split("@")[1].split("_").join(" ")
              : tmp[index].split("#")[1].split("_").join(" ");
            end = temp === item.name ? true : false;
          } else {
            end = tmp[index] === item.name ? true : false;
          }
        }
      }
      str = item.file ? str : str + "/";
      str2 = item.file ? str2 : str2 + "/";
      this.itemToLock.name = str;
      this.itemToLock.path = str2;
      this.itemToLock.bucket = this.bucket;
      this.itemToLock.action = item.locked ? "open" : "lock";
      this.itemToLock.msg = "This action will lock this element";
      this.dialog = true;
    },
    confirm(item) {
      let tmp = item.el_properties.name.split("/");
      let tmp2 = item.el_properties.path.split("/");
      let str = "";
      let str2 = "";
      let end = false;
      for (let index = 0; index < tmp.length; index++) {
        if (!end) {
          str = path.join(str, tmp[index]);
          str2 = path.join(str2, tmp2[index]);
          let temp;
          if (tmp[index].includes("@") || tmp[index].includes("#")) {
            temp = tmp[index].includes("@")
              ? tmp[index].split("@")[1].split("_").join(" ")
              : tmp[index].split("#")[1].split("_").join(" ");
            end = temp === item.name ? true : false;
          } else {
            end = tmp[index] === item.name ? true : false;
          }
        }
      }
      str = item.file ? str : str + "/";
      str2 = item.file ? str2 : str2 + "/";
      this.itemToLock.email = this.user.email;
      this.itemToLock.name = str;
      this.itemToLock.path = str2;
      this.itemToLock.bucket = this.bucket;
      this.itemToLock.action = "confirm";
      this.itemToLock.msg = "This action will confirm this element";
      this.dialog = true;
    },
    sendConfirm: async function () {
      if (this.itemToLock.action === "confirm") {
        await this.$store.dispatch("confirmFileAction", this.itemToLock);
      } else {
        await this.$store.dispatch("setStateItem", this.itemToLock);
      }
      this.dialog = false;
    },
    async fetchItems(item) {
      let tmp = item.el_properties.name.split("/");
      tmp.pop();
      let ff = "";
      for (let i = 0; i < tmp.length - 1; i++) {
        ff = path.join(ff, tmp[i]);
      }
      await this.$store.dispatch("setTree", {
        bucket: this.bucket,
        father: item.el_properties.name,
        parent: ff ? ff.concat("/") : ff,
      });
    },
    async serveSideFilter() {
      this.loading = true;
      if (this.search.length <= 200) {
        await this.$store.dispatch("getSearchFile", {
          bucket: this.bucket,
          search: this.search,
        });
      } else {
        this.search = "";
        this.$store.dispatch("dispatchError", {
          text: { message: "Too long field" }.message.substr(0, 50) + "...",
          type: "danger",
        });
      }
      this.loading = false;
    },
    async serveSideFilterReset() {
      await this.$store.dispatch("setTree", {
        bucket: this.bucket,
        father: "",
        parent: "",
      });
      this.$refs.form.reset();
    },
    makeDeliverable() {
      this.loading = true;
      // let elementToDeliver = this.itemToDeliver.el_properties.name.split('/')
      // elementToDeliver.shift();
      console.log('elementToDeliver', this.itemToDeliver)
      this.$store.dispatch("makeFolderDeliverable", { elementToDeliver: this.itemToDeliver.el_properties.name,  deliverFolder: this.folderToUploadSharedFile});
      this.loading = false;
    },
    async setTreeProvider(item) {
      this.itemToDeliver = item;
      this.md_dialog = false;
      this.loading = true;
      this.$store.commit("resetPathToShare", []);
      await this.$store.dispatch("setTreeToShare", {
        bucket: this.getBucket(),
        father: this.kind.includes("Provider") ? "" : this.fatherPath(item.el_properties.name),
        parent: "",
      });
      if(!this.kind.includes("Provider")) {
        await this.$store.commit("setFolderToUploadSharedFile", "");
        let folderToUpload = {
          path: this.fatherPath(item.el_properties.name),
          name: this.fatherPath(item.el_properties.name),
        };
        await this.$store.dispatch("setFolderToUploadSharedFileAction", folderToUpload);
      }
      this.md_dialog = true;
      this.loading = false;
    },
    closeMdDialog() {
      this.itemToDeliver = {};
    }
  },
};
</script>
<style>
.v-treeview-node__root {
  height: 20px;
}
</style>